<template>
  <div class="custom-emoji-com" @click.stop="()=>{}">
    <el-tabs :tab-position="tabposition" type="border-card" class="wrapper">
      <el-tab-pane v-for="(value, key, index) in emojisList" :label="key" :key="index" addable>
        <span slot="label"><i :class="emijoIconClassNameMap[key]"></i> </span>
        <span
          class="emoji-item"
          v-for="(item, index) in value"
          :key="index"
          @click.stop="selectItem(item)"
        >
          {{item}}
        </span>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import emojis from './emoji.json'

  export default {
    props: {
      tabposition: {
        type: String,
        default() {
          return 'bottom'
        }
      }
    },
    data() {
      return {
        emojisList: emojis.data,
        selectedEmoji: '',
        emijoIconClassNameMap: {
          face: 'iconfont icon-icon_xiaolian',
          heart: 'iconfont icon-icon_xin',
          food: 'iconfont icon-icon_shiwu',
          drink: 'iconfont icon-icon_yinliao',
          animal: 'iconfont icon-icon_maozhua'
        }
      }
    },
    methods: {
      selectItem(item) {
        this.$emit('addemoji', item)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .custom-emoji-com {
    width: 100%;

    .wrapper {
      transition: all .5s ease;
      border-radius: 4px;

      .emoji-item {
        cursor: pointer;
        display: inline-block;
        width: 28px;
        height: 28px;
        padding: 3px;
        text-align: center;
      }
    }
  }
</style>
